import { c as _c } from "react/compiler-runtime";
import React from "react";
import DropPartMarkdownWithPropLogger from "@/components/drops/view/part/DropPartMarkdownWithPropLogger";
import WaveDropQuoteWithDropId from "./WaveDropQuoteWithDropId";
import EditDropLexical from "./EditDropLexical";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import type { ApiDrop } from "@/generated/models/ApiDrop";
interface WaveDropPartContentMarkdownProps {
  readonly mentionedUsers: Array<ApiDropMentionedUser>;
  readonly mentionedWaves: Array<ApiMentionedWave>;
  readonly referencedNfts: Array<ApiDropReferencedNFT>;
  readonly part: ApiDropPart;
  readonly wave: ApiWaveMin;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly drop?: ApiDrop | undefined; // Add drop to check for edited status
  readonly marketplaceImageOnly?: boolean | undefined;
}
const WaveDropPartContentMarkdown: React.FC<WaveDropPartContentMarkdownProps> = t0 => {
  const $ = _c(40);
  const {
    mentionedUsers,
    mentionedWaves,
    referencedNfts,
    part,
    wave,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    drop,
    marketplaceImageOnly: t3
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const marketplaceImageOnly = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== drop || $[1] !== wave) {
    t4 = drop?.serial_no === undefined ? [] : [`${wave.id}:${drop.serial_no}`];
    $[0] = drop;
    $[1] = wave;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const currentQuotePath = t4;
  if (isEditing) {
    const t5 = part.content ?? "";
    let t6;
    if ($[3] !== onSave) {
      t6 = (content, mentions, waves) => {
        if (onSave) {
          onSave(content, mentions, waves);
        }
      };
      $[3] = onSave;
      $[4] = t6;
    } else {
      t6 = $[4];
    }
    let t7;
    if ($[5] !== onCancel) {
      t7 = () => {
        if (onCancel) {
          onCancel();
        }
      };
      $[5] = onCancel;
      $[6] = t7;
    } else {
      t7 = $[6];
    }
    let t8;
    if ($[7] !== isSaving || $[8] !== mentionedUsers || $[9] !== mentionedWaves || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== wave.id) {
      t8 = <EditDropLexical initialContent={t5} initialMentions={mentionedUsers} initialWaveMentions={mentionedWaves} waveId={wave.id} isSaving={isSaving} onSave={t6} onCancel={t7} />;
      $[7] = isSaving;
      $[8] = mentionedUsers;
      $[9] = mentionedWaves;
      $[10] = t5;
      $[11] = t6;
      $[12] = t7;
      $[13] = wave.id;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    return t8;
  }
  const t5 = drop?.id;
  const t6 = drop?.hide_link_preview;
  let t7;
  if ($[15] !== currentQuotePath || $[16] !== marketplaceImageOnly || $[17] !== mentionedUsers || $[18] !== mentionedWaves || $[19] !== onQuoteClick || $[20] !== part.content || $[21] !== referencedNfts || $[22] !== t5 || $[23] !== t6) {
    t7 = <DropPartMarkdownWithPropLogger mentionedUsers={mentionedUsers} mentionedWaves={mentionedWaves} referencedNfts={referencedNfts} partContent={part.content} onQuoteClick={onQuoteClick} currentDropId={t5} hideLinkPreviews={t6} marketplaceImageOnly={marketplaceImageOnly} quotePath={currentQuotePath} />;
    $[15] = currentQuotePath;
    $[16] = marketplaceImageOnly;
    $[17] = mentionedUsers;
    $[18] = mentionedWaves;
    $[19] = onQuoteClick;
    $[20] = part.content;
    $[21] = referencedNfts;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== drop) {
    t8 = drop?.updated_at && drop.updated_at !== drop.created_at && <div className="tw-mt-0.5 tw-text-[10px] tw-font-normal tw-leading-none tw-text-iron-500">(edited)</div>;
    $[25] = drop;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t7 || $[28] !== t8) {
    t9 = <div>{t7}{t8}</div>;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== currentQuotePath || $[31] !== drop || $[32] !== marketplaceImageOnly || $[33] !== onQuoteClick || $[34] !== part.quoted_drop || $[35] !== wave) {
    t10 = part.quoted_drop?.drop_id && <div className="tw-mt-1.5"><WaveDropQuoteWithDropId dropId={part.quoted_drop.drop_id} partId={part.quoted_drop.drop_part_id} maybeDrop={part.quoted_drop.drop ? {
        ...part.quoted_drop.drop,
        wave
      } : null} onQuoteClick={onQuoteClick} embedPath={drop?.id ? [drop.id] : []} quotePath={currentQuotePath} marketplaceImageOnly={marketplaceImageOnly} embedDepth={1} /></div>;
    $[30] = currentQuotePath;
    $[31] = drop;
    $[32] = marketplaceImageOnly;
    $[33] = onQuoteClick;
    $[34] = part.quoted_drop;
    $[35] = wave;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[37] = t10;
    $[38] = t9;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  return t11;
};
export default WaveDropPartContentMarkdown;